import { useState, useEffect } from "react";
import { Collapse } from "react-bootstrap";
import "../../assets/styles/maps.scss";
import api from "../../services/httpClient";

const MapsLayersList = ({ onLayerSelect }) => {
  const [layersList, setLayersList] = useState([]);
  const [selectedLayer, setSelectedLayer] = useState(null);
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    const fetchLayers = async () => {
      try {
        const response = await api.get("/Layer/List");
        const data = Array.isArray(response.data?.items)
          ? response.data.items
          : [];
        setLayersList(data);
      } catch (error) {
        console.error("Failed to fetch layers:", error);
        setLayersList([]);
      }
    };

    fetchLayers();
  }, []);

  const handleLayerSelect = (layerId) => {
    // Toggle selection - if clicking the same layer, deselect it
    if (selectedLayer === layerId) {
      setSelectedLayer(null);
      if (onLayerSelect) {
        console.log("Layer deselected");
        onLayerSelect(null);
      }
    } else {
      setSelectedLayer(layerId);
      // Find the full layer object and pass it to parent
      const layer = layersList.find((l) => l.id === layerId);
      if (layer && onLayerSelect) {
        onLayerSelect(layer);
      }
    }
  };

  return (
    <>
      <h4 className="layers-main-title">Wybierz warstwę:</h4>
      <div className="layers-list-container">
        <div
          className="layers-header"
          onClick={() => setIsExpanded(!isExpanded)}
        >
          <h5 className="mb-0">Warstwy mapy</h5>
          <span className={`arrow ${isExpanded ? "expanded" : ""}`}>▼</span>
        </div>

        <Collapse in={isExpanded}>
          <div className="layers-scroll-list">
            {Array.isArray(layersList) && layersList.length > 0 ? (
              layersList.map((layer) => (
                <div
                  key={layer.id}
                  className={`layer-item ${
                    selectedLayer === layer.id ? "selected" : ""
                  }`}
                  onClick={() => handleLayerSelect(layer.id)}
                >
                  <span>{layer.name}</span>
                </div>
              ))
            ) : (
              <div className="layer-item">
                <span>Brak dostępnych warstw</span>
              </div>
            )}
          </div>
        </Collapse>
      </div>
    </>
  );
};

export default MapsLayersList;
